module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_iter-step.js
// module id = 443
// module chunks = 0